/**
 * PATH: packages/email-hub/src/feature/email-layout/EmailSidebar.tsx
 * FILE_ID: EMAIL-LAYOUT-SIDEBAR-FRAME-001
 * PURPOSE: Assemble Email navigation without owning behavior.
 */

import { CapacityBadge } from '../../_internal/components/CapacityBadge'
import { cn } from '../../_internal/lib/utils'
import { EmailSidebarFooter } from './EmailSidebarFooter'
import { EmailSidebarNavigation } from './EmailSidebarNavigation'
import { EmailSidebarSync } from './EmailSidebarSync'
import { EmailSidebarTools } from './EmailSidebarTools'
import { EmailSidebarTop } from './EmailSidebarTop'
import type { EmailLayoutController } from './useEmailLayoutController'

export function EmailSidebar({
  layout,
}: {
  layout: EmailLayoutController
}) {
  if (layout.useBottomNav || layout.hostDockReplacesNav) return null

  return (
    <aside
      className={cn(
        'flex flex-col overflow-hidden border-border',
        layout.navOnRight ? 'border-l order-2' : 'border-r order-1',
        layout.isNarrow ? 'bg-card' : 'bg-muted/30',
        layout.isNarrow
          ? cn(
              'fixed inset-y-0 left-0 z-[55] w-64 shadow-2xl transition-transform duration-200',
              layout.mobileNavOpen
                ? 'translate-x-0'
                : '-translate-x-full',
            )
          : cn(
              'shrink-0 transition-all duration-200',
              layout.collapsed ? 'w-[52px]' : 'w-56',
            ),
      )}
    >
      <EmailSidebarTop layout={layout} />
      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">
        <EmailSidebarNavigation layout={layout} />
        <EmailSidebarTools layout={layout} />
        <EmailSidebarSync layout={layout} />

        {/* /BUG-2026-05-15-SAM-EMAIL-ASIDE-9741PX scroll wrapper.
            Capacity remains inside the scroll region; Recent issues and
            collapse controls stay pinned below this boundary. */}
        {!layout.collapsed && (
          <div className="border-t border-border px-3 py-2 flex justify-center">
            {/* Capacity badge — only renders when the master backend is busy. */}
            <CapacityBadge variant="inline" />
          </div>
        )}
      </div>
      <EmailSidebarFooter layout={layout} />
    </aside>
  )
}
